
import React from 'react';

import AssetManager from '@components/workbench/individual/asset_manager/main';
import Text from '@components/workbench/individual/text/text';

class TextExtractor extends React.Component {
  render() {
    return (
      <AssetManager extractText>
        <Text />
      </AssetManager>
    );
  }
}

export default TextExtractor;
